export default {
  menus: {
    '/': '可视化分析',
    home: '可视化分析',
    users: '用户列表',
    roles: '角色列表',
    rights: '权限列表',
    goods: '商品列表',
    params: '分类参数',
    categories: '商品分类',
    orders: '订单列表',
    reports: '数据报表'
  },
  // 登录
  login: {
    title: '授权登录',
    btnTitle: '登录'
  },
  dialog: {
    deleteTitle: '确定要删除用户'
  },
  // 用户
  userTable: {
    username: '用户名',
    realName: '姓名',
    name: '姓名',
    department: '区域',
    position: '职位',
    Teacher: '在编教职工',
    student: '学生',
    other: '其他',
    system: '系统管理员',
    type: '类型',
    phone: '电话',
    placeholder: '请输入搜索的用户姓名',
    placeholder1: '请输入搜索的用户昵称',
    man: '男',
    woman: '女',
    gender: '性别',
    password: '密码',
    nickName: '昵称',
    email: '邮箱',
    departmentName: '所属区域',
    roleName: '所属角色',
    userList: '人员列表',
    vehicleList: '车辆列表',
    routeList: '路线列表'
  },
  user: {
    add: '新增用户',
    edit: '编辑用户'
  },
  // 列表公共部分
  table: {
    Controls: '操作',
    createTime: '创建时间'
  },
  // 角色
  role: {
    roleId: '角色ID',
    roleCode: '角色编码',
    roleName: '角色名称',
    remark: '备注',
    search: '请输入角色名称',
    edit: '编辑角色',
    add: '新增角色'
  },
  // 部门
  department: {
    placeholder: '请输入区域名称',
    departmentName: '区域名称',
    parentName: '所属区域',
    phone: '部门电话',
    address: '部门地址',
    orderNum: '排序',
    add: '新增区域',
    edit: '编辑区域'
  },
  // 菜单
  menu: {
    menuName: '菜单名称',
    menuType: '菜单类型',
    menuIcon: '菜单按钮',
    routeName: '路由名称',
    routeAddress: '路由地址',
    moduleAddress: '组件地址',
    catalog: '目录',
    menu: '菜单',
    button: '按钮',
    routPath: '路由地址',
    permission: '权限字段',
    pagePath: '页面地址',
    buttonName: '按钮名称',
    qwning: '所属菜单',
    orderNum: '序号',
    name: '名称',
    icon: '图标',
    add: '新增菜单',
    edit: '编辑菜单'
  },
  // 教室
  site: {
    ID: 'ID',
    locationNumber: '教室编号',
    buildingName: '楼房名称',
    classroomName: '教室名称',
    numberOfSeats: '座位数量',
    row: '行',
    column: '列',
    customCol: '自定义行列',
    addCol: '添加行列',
    add: '新增教室',
    edit: '编辑教室',
    createSeats: '生成座位',
    editSeats: '编辑座位',
    setSeats: '设置座位',
    type: '教室类型',
    status: '预约状态',
    mode: '选座模式',
    number: '座位数量'
  },
  // 课程
  course: {
    courseCode: '课程编号',
    courseName: '课程名称',
    type: '课程类型',
    img: '封面'
  },
  coursesType: {
    type: '课程类型',
    add: '新增课程类型',
    edit: '编辑课程类型'
  },
  // 时间
  time: {
    timeCode: '时间编号',
    startTime: '开始时间',
    endTime: '结束时间',
    timeName: '课时名称'
  },
  // 教室编号
  seatCode: {
    code: '教室编号',
    add: '新增编号',
    edit: '编辑编号'
  },
  // 教室类型
  classType: {
    type: '教室类型',
    add: '新增教室类型',
    edit: '编辑教室类型'
  },
  building: {
    buildingName: '楼房名称',
    add: '新增楼房',
    edit: '编辑楼房'
  },
  // 车辆管理
  vehicle: {
    add: '新增车辆',
    edit: '编辑车辆',
    vehicleCode: '车辆编号',
    licensePlate: '车牌号',
    vehicleName: '车辆名称',
    model: '车辆型号',
    color: '车辆颜色',
    numPeople: '承载人数',
    vehicleStatus: '车辆状态',
    dynamic: '活跃',
    inertia: '不活跃',
    maintenance: '维修中'
  },
  // 线路
  route: {
    add: '新增路线',
    edit: '编辑路线',
    routeCode: '路线编号',
    routeName: '路线名称',
    startStation: '起点站',
    endStation: '终点站',
    totalDuration: '路线长度',
    active: '路线状态',
    operation: '运营中',
    ceaseOperation: '停止运营'
  },
  trip: {
    code: '预约编号',
    username: '预约人姓名',
    name: '车辆名称',
    routeName: '预约线路',
    startStation: '预约起点',
    destination: '预约终点',
    reservationDate: '预约日期',
    seatsNeeded: '预约人数',
    status: '状态',
    beConfirmed: '待确认',
    confirmed: '已确认',
    canceled: '已取消',
    reservation: '预约人选择列表',
    vehicleBook: '预约车辆选择列表',
    lineBook: '预约线路选择列表'
  },
  // 公告
  affiche: {
    afficheCode: '公告编号',
    title: '公告名称',
    content: '公告内容',
    startTime: '展示时间',
    endTime: '结束时间',
    isActive: '公告状态',
    delist: '已下架',
    onDisplay: '正在展示',
    username: '创建人',
    add: '新增公告',
    edit: '编辑公告'
  },
  // 课程管理
  curriculum: {
    code: '课程编号',
    username: '教师',
    siteName: '教室',
    coursesDay: '日期',
    coursesName: '课程名称',
    timesName: '课时',
    category: '类别',
    giveLessons: '授课',
    exam: '考试',
    report: '学术报告',
    thesis: '实验',
    timeFrame: '课程时段',
    add: '新增课程',
    edit: '课程编辑'
  },
  // 预约管理
  subscribe: {
    appointments: '今日预约数',
    sign: '今日签到数',
    departures: '今日签离数',
    week: '本周签到数',
    username: '用户名',
    buildingName: '楼房',
    siteName: '教室',
    seatNumber: '座位',
    bookingDate: '预约日期',
    timeName: '课时',
    startTime: '开始时间',
    endTime: '结束时间',
    status: '状态',
    notSignedIn: '未签到',
    signedIn: '已签到',
    signedOut: '已签退',
    selecDate: '选择日期',
    selecSite: '选择教室'

  },
  // 资源类别
  rCategories: {
    code: '资源编码',
    categoryName: '资源名称',
    categoryType: '资源标识',
    add: '新增资源类别',
    edit: '编辑资源类别'
  },
  // 推送设置
  pushSettings: {
    userName: '用户名称',
    categoryName: '资源名称',
    isEnabled: '是否可以',
    settings: '推送设置'
  },
  // 推送消息
  pushMessage: {
    code: '编码',
    categoryName: '资源名称',
    title: '标题',
    description: '描述',
    publishTime: '发布时间',
    contents: '内容',
    add: '新增消息',
    edit: '编辑消息'
  },
  personnel: {
    name: '名称',
    code: '编号'
  },
  // 提示
  message: {
    updeteSuccess: '更新成功',
    addSuccess: '新增成功',
    deleteSuccess: '删除成功',
    updeteFail: '更新失败',
    addFail: '新增失败',
    deleteFail: '删除失败',
    deleteMsg: '你确定要删除吗?',
    systemPrompt: '系统提示',
    deleteMsg1: '确定对选中用户进行角色分配吗？这将导致覆盖掉原先用户拥有的角色！',
    setASeat: '确定要将选中的座位设置为不可用吗？',
    unbanSeat: '确定要解禁该座位吗？'
  },
  // 引导
  driver: {
    doneBtnText: '完成',
    closeBtnText: '关闭',
    nextBtnText: '下一步',
    prevBtnText: '上一步',
    guideBtn: '引导按钮',
    hamburgerBtn: '汉堡按钮',
    fullScreen: '全屏按钮'
  },
  // 个人中心
  personal: {
    personal: '个人中心',
    password: '修改密码',
    quit: '退出'

  },
  // 按钮
  buttons: {
    add: '新增',
    edit: '编辑',
    delete: '删除',
    search: '查询',
    reset: '重置',
    assignment: '统一角色分配',
    allocation: '角色分配',
    cancel: '取消',
    confirm: '确定',
    authority: '分配权限',
    view: '查看',
    generating: '生成座位',
    viewSeate: '设置座位',
    distribution: '分配线路',
    pushSetting: '推送设置',
    viewPush: '资源推送',
    synchronizing: '同步用户数据',
    import: '导入用户',
    campus: '校园助手',
    relevancy: '选择关联'
  },
  // 登录日志
  logingzh: {
    loginName: '登录名 ',
    operatingSystem: '操作系统',
    client: '客户端',
    browser: '浏览器',
    loginTime: '登录时间'

  },
  // 操作日志
  requestlog: {
    IPAddress: 'IP地址',
    Geolocation: '归属地',
    Operator: '操作人员',
    OperationMethod: '操作方式',
    OperationStatus: '操作状态',
    OperationTime: '操作时间',
    OperationDuration: '操作耗时(毫秒)',
    LogDetails: '日志详情',
    RequestIP: '请求IP',
    RequestURL: '请求URL',
    ErrorMessage: '错误消息',
    RequiredParameter: '请求参数',
    ResponseParameter: '响应参数'

  },
  // 首页
  home: {
    total: '学生总人数',
    appointments: '今日预约数量',
    vehicles: '今日车辆数',
    sign: '今日签到数'
  },
  stop: {
    name: '站点名称'
  }
}
